import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { Auth, onAuthStateChanged } from "@angular/fire/auth";
import { firstValueFrom } from "rxjs";
import { take } from "rxjs/operators";

/**
 * Auth guard that requires authentication (anonymous or authenticated user)
 * Redirects to home if not authenticated
 */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Promise<boolean>((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) {
        // User is authenticated (anonymous or signed in)
        resolve(true);
      } else {
        // No user - redirect to home
        console.log("[AuthGuard] No authenticated user, redirecting to home");
        router.navigate(["/home"], {
          queryParams: { returnUrl: state.url },
          replaceUrl: true,
        });
        resolve(false);
      }
    });
  });
};
